import { shimmer, toBase64 } from "@src/utils/shimmer";
import Image from "next/image";
import React from "react";
import flower from "../../../../public/images/pinkFlowerImage.png";
import { EventBySlugQuery } from "@src/@types/api.d";
import Icon from "@src/components/Icon";

interface IFooter {
  slug: EventBySlugQuery | undefined;
}

const Footer = ({ slug }: IFooter) => {
  return (
    <footer className="h-[25rem] w-full overflow-hidden bg-[rgba(42,46,50,1)] flex flex-col justify-start items-center">
      <div className="h-[15rem] flex flex-col gap-2 justify-center items-center relative px-8 overflow-hidden">
        <Icon iconName="ringWhite" />

        <p className="font-brooklyn text-[1rem] md:text-[1.5rem] leading-[100%] mt-[2rem] font-normal tracking-[0.2rem] text-[rgba(255,255,255,1)]">
          MADE WITH{" "}
          <a
            href="https://www.inawo.com"
            target="_blank"
            rel="noopener noreferrer"
            className="border-b-[0.5px] font-andalusia border-[rgba(255,255,255,1)] pb-[0.5px]"
          >
            Inawo
          </a>
        </p>

        <p className="font-brooklyn text-[1rem] md:text-[1.5rem] leading-[100%] mt-[0.5rem] w-[80%] md:w-full text-[rgba(255,255,255,1)] text-center">
          The number one website maker for the culturally relevant
        </p>
      </div>
    </footer>
  );
};

export default Footer;
